// extracted by mini-css-extract-plugin
export default {"content":"CartItem_content__nMqUe","text__left":"CartItem_text__left__pUynd","text":"CartItem_text__5i5Ed","btn":"CartItem_btn__K7495"};